Ext.define('SA.CrosstabAttributesPanelItem', {
    alias: 'widget.crosstab-attributes-panel-item',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-crosstab-attributes-panel-item',

    initComponent() {
        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-crosstab-attributes-panel-item-row-button-wrap',

                items: [
                    {
                        xtype: 'check-button',
                        itemId: 'rowCheckButton'
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-crosstab-attributes-panel-item-column-button-wrap',

                items: [
                    {
                        xtype: 'check-button',
                        itemId: 'columnCheckButton'
                    }
                ]
            }, {
                xtype: 'component',
                cls: 'sa-crosstab-attributes-panel-item-label',
                html: SA.EditItemLabelFactory.forAttributes().create(this.dataId)
            }
        ];

        this.callParent();

        this.rowCheckButton = this.down('#rowCheckButton');
        this.columnCheckButton = this.down('#columnCheckButton');
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onElClick, this);
        this.rowCheckButton.on('click', this.onRowButtonClick, this);
        this.columnCheckButton.on('click', this.onColumnButtonClick, this);
    },

    fireChange() {
        this.fireEvent('change', {attribute: this.getDataId(), state: this.getState()});
    },

    getDataId() {
        return this.dataId;
    },

    getState() {
        var row = this.rowCheckButton.isChecked(),
            column = this.columnCheckButton.isChecked();

        return {row, column};
    },

    onColumnButtonClick() {
        this.rowCheckButton.setChecked(false);

        this.fireChange();
    },

    onElClick() {
        var state = this.getState();

        this.setState({
            row: !state.row && !state.column,
            column: state.row
        });

        this.fireChange();
    },

    onRowButtonClick() {
        this.columnCheckButton.setChecked(false);

        this.fireChange();
    },

    setState({row, column}) {
        this.rowCheckButton.setChecked(row);
        this.columnCheckButton.setChecked(column);
    }
});